import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from 'api/methods';

import * as types from './types';

export const getUnsubscribeReasons = createAsyncThunk<any, any>(
  types.GET_UNSUBSCRIBE_REASONS,
  async (params: Record<string, any>) => {
    const unsubscribeReasons = await api.getStudentUnsubscribeReasons(params);
    return unsubscribeReasons;
  },
);

export const getUnsubscribeReasonsByStudentId = createAsyncThunk<any, any>(
  types.GET_UNSUBSCRIBE_REASONS_BY_STUDENT_ID,
  async ({
    studentId,
    ...params
  }: {
    studentId: string;
    params: Record<string, any>;
  }) => {
    const unsubscribeReasons =
      await api.getStudentUnsubscribeReasonsByStudentId({
        studentId,
        params,
      });
    return unsubscribeReasons;
  },
);
